import {Injectable} from "@angular/core";
import {AssetForSiteDesignModel, assetForSiteDesignModelListFactory} from "../asset/asset-for-site-design.model";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

const DEFAULT_PAGE = "1";
const DEFAULT_PAGE_LIMIT = "10";

@Injectable()
export class SiteDesignService {
  private url: string = "/api/site-design";

  constructor(private http: HttpClient) {}

  getCurrentSiteDesign(
    page: string = DEFAULT_PAGE,
    limit: string = DEFAULT_PAGE_LIMIT,
    search: string,
    siteId: string,
  ): Promise<{rows: AssetForSiteDesignModel[], count: number, isMigrationActive: boolean}> {
    const params = {page, limit, search: search || "", siteId, sequence: "true"};

    return this.http.get<{rows: AssetForSiteDesignModel[], count: number, isMigrationActive: boolean}>(`${this.url}/current-site-design`, {params})
      .map(({rows, count, isMigrationActive}) => ({rows: assetForSiteDesignModelListFactory(rows), count: +count, isMigrationActive}))
      .toPromise();
  }

  getDevicesForSiteDesign(
    page: string = DEFAULT_PAGE,
    limit: string = DEFAULT_PAGE_LIMIT,
    search: string,
    projectId: string,
  ): Promise<{rows: any[], count: number}> {
    const params = {page, limit, search: search || "", projectId, sequence: "true"};

    return this.http.get<{rows: any, count: number}>(`${this.url}/devices`, {params})
      .map(({rows, count}) => ({rows, count: +count}))
      .toPromise();
  }

  getAccessoryFixData(siteId: string, assetId: string, serialNumber: string): Promise<any[]> {
    const params = {siteId, assetId, serialNumber: serialNumber || ""};

    return this.http.post<{assets: any[]}>(`${this.url}/get-accessory-fix-data`, params)
      .pipe(map(json => Array.from(json["assets"] || [])))
      .toPromise();
  }

  fixAccessoryData(
    siteId: string,
    srcAssetId: string,
    destAssetId: string,
    attachToOrder: boolean,
    attachToDeployment: boolean,
  ): Promise<boolean> {
    const params: {[key: string]: string} = {
      siteId,
      srcAssetId,
      destAssetId: destAssetId || "",
      attachToOrder: `${attachToOrder}`,
      attachToDeployment: `${attachToDeployment}`,
    };

    return this.http.post<{success: boolean}>(`${this.url}/fix-accessory-data`, params)
      .pipe(map(json => !!json["success"]))
      .toPromise();
  }

  getUnassociatedStandaloneAccessories(
    page = DEFAULT_PAGE,
    limit = DEFAULT_PAGE_LIMIT,
    search = "",
    deploymentId = "",
  ): Promise<any> {
    const params = {
      deploymentId: `${deploymentId}`,
      search: search || "",
      page: `${page}`,
      limit: `${limit}`,
      sequence: "true",
    };
    return this.http.get(`${this.url}/unassociated-standalone-accessories`, {params})
      .toPromise();
  }

  getAvailableAssetsToAssociateStandaloneAccessories(deploymentId = "", page = 0, limit = 10): Promise<any> {
    const params = {
      deploymentId: `${deploymentId}`,
      page: `${page}`,
      limit: `${limit}`,
      sequence: "true",
    };
    return this.http.get(`${this.url}/get-available-assets-to-associate-standalone-accessories`, {params})
      .toPromise();
  }

  associateStandaloneAccessoryToAsset(accessoryId, assetId): Promise<any> {
    const params = {
      accessoryId: `${accessoryId}`,
      assetId: `${assetId}`,
    };
    return this.http.post(`${this.url}/associate-standalone-accessory-to-asset`, params)
      .pipe(map(json => !!json["success"]))
      .toPromise();
  }
}
